export class DeferredEventsClient {
    constructor() {
        this.deferredEvents = [];
        this.deferEvent = (definition, meta) => {
            this.deferredEvents.push([definition, meta]);
        };
        this.sendDeferredEvents = (sendEvent) => {
            this.deferredEvents.forEach(event => sendEvent(...event));
            this.deferredEvents = [];
        };
    }
}
